import { type ContentFilmListProps, getSSRData } from 'src/lib/pages/ContentFilmList';
import styles from "./FolketsAmanda.module.css";
import ContentWrapper from "src/components/contentwrapper/ContentWrapper";
import ContentFilmListSeo from "src/components/seo/ContentFilmListSeo";
import Picture, { PictureFallbackImage, PictureSource } from "src/components/images/Picture";
import Image from "next/image";
import FilmListWithProviders from "src/components/filmlistwithproviders/FilmListWithProviders";
import VotingButton from "src/components/votingbutton/VotingButton";
import VotingResponse from "src/components/votingbutton/VotingResponse";
import { type CSSProperties } from "react";

export const SECTION_ID = "folketsamabda2025";
const FOLKETS_AMANDA_GDPR_ID = 56;

//#region [Other]getServerSideProps
export const getServerSideProps = getSSRData(SECTION_ID);
//#endregion

export default function ContentFilmList({ appData, contentFilmList }: ContentFilmListProps) {
    const style = { "--cfl-themecolor": contentFilmList.themeColor?.hex ?? "#ffffff" } as CSSProperties
    return <ContentWrapper as="section" style={style} >
        <ContentFilmListSeo contentFilmList={contentFilmList} />

        {contentFilmList.imageDesktop && contentFilmList.imageMobile && <Picture className={styles.TopImage}>
            <PictureSource media="(min-width: 1600px)" cmsImage={contentFilmList.imageDesktop} width={2000} />
            <PictureSource media="(min-width: 641px)" cmsImage={contentFilmList.imageDesktop} width={1200} />
            <PictureFallbackImage cmsImage={contentFilmList.imageMobile} alt={contentFilmList.imageDesktop?.asset?.altText ?? contentFilmList?.imageMobile?.asset?.altText ?? contentFilmList.title} />
        </Picture>}
        <div className={styles.ContentContainer}>
            <header className={styles.PageHeader}>
                <Image className={styles.NIFFHLogo} src="/staticimages/film_fest_logo.webp" alt="The Norwegian International Film Festival Haugesund" width={823} height={205} />
                <h1 className={styles.PageTitle}>{contentFilmList.title}</h1>
            </header>
            <FilmListWithProviders films={contentFilmList.films} hideKinoklubb noFilmsMessage="Årets filmer er ikke publisert enda.">
                <VotingButton gdprId={FOLKETS_AMANDA_GDPR_ID} voteAppId={1} className={styles.VoteButton} formClassName={styles.VotingForm} title="STEM PÅ FOLKETS AMANDA!" style={style}/>
            </FilmListWithProviders>
            <VotingResponse style={style} className={styles.VotingForm} message="Takk for din stemme til Folkets Amanda! Følg med på Amandaprisutdelingen lørdag 16. august på NRK 1" title="FOLKETS AMANDA" />

        </div>

    </ContentWrapper>;
}